import './appointments_calendar.scss';
import { AddOutlined, Refresh } from '@mui/icons-material';
import { Box, Button, Container, Grid, styled } from '@mui/material';
import Alert from '@mui/material/Alert';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { useAppointmentsCalendarContext } from 'components/appointment_calendar_context';
import { CaleculateAge } from 'components/helpers';
import dayjs from 'dayjs';
import Localization from 'l18n/l18n';
import Appointments from 'models/appointments';
import CalendarHeader from 'pages/appointments_calendar/components/appointments_header';
import Calendar from 'pages/appointments_calendar/components/calendar';
import CalendarTopbar from 'pages/appointments_calendar/components/calendar_topbar';
import * as React from 'react';
import { Helmet } from 'react-helmet';

var utc = require('dayjs/plugin/utc');
var isSameOrAfter = require('dayjs/plugin/isSameOrAfter');
var isSameOrBefore = require('dayjs/plugin/isSameOrBefore');

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(utc);
require('dayjs/locale/ar');

const StyledButton = styled(Button)({
 
  backgroundColor:'#279BFF',
  color:'#ffffff',
  fontSize:'1rem',
  minWidth:'10rem',
  borderRadius:0,
  boxShadow:'none',
});
export default function AppointmentsCalendar() {
  const appointmentContext = useAppointmentsCalendarContext();
  const {setContext, currentWeek, setCurrentWeek } = appointmentContext;
  const [loading, setLoading] = React.useState(true);
 
  const [dialogs,setDialogs] = React.useState({
    WeekendOpen:false,
    exceptionsOpen:false,
    availableTimeOpen:false
  });
  const changeDialogsOpenState = (name,open) => {
    setDialogs((previous)=>{
      return {...previous,[name]:open};
    });
  };
  const setNextWeekDate = () =>
    setCurrentWeek(dayjs(currentWeek).add(1, 'week'));
  const setPreviousWeekDate = () => setCurrentWeek(dayjs(currentWeek).subtract(1, 'week'));
  const [showEmptyDataAlert, setEmptyDataAlert] = React.useState(false);
  const [isError, setError] = React.useState(false);
  const [calendarConfig, setCalendarConfig] = React.useState({
    timeDuration: {
      startTime: dayjs().get('h'),
      endTime: dayjs().add(1).get('h'),
    },
    cellTimeDuration: 30,
    appointmentsData: [],
    exceptionDates:[]
  });

 const getExceptionDates = async () => {
 
  return await Appointments.getExceptionDates().then(async (exceptionDates) => {
   
  return Promise.resolve(exceptionDates);
  
  }).catch((err) => {
    console.log(err);
    return Promise.reject(err);
  });
 };

  const getAppointmentsCalendar = async (currentWeek) => {
    setLoading(true);
    setError(false);
    setEmptyDataAlert(false);
    const CurrentDateFormat = dayjs(currentWeek);
    // calendar start and end date
    const StartDate = CurrentDateFormat.format('YYYY-MM-DD');
    const EndDate = CurrentDateFormat.add(7, 'day').format('YYYY-MM-DD');

    // get appointments calendar
    const result = Appointments.getAllAppointments(StartDate, EndDate)
      .then(async (response) => {
        // check if result if 0 then show an empty message
        if (response.length < 1) {
          setEmptyDataAlert(true);
          setLoading(false);
          setCalendarConfig((previous)=>({...previous,   timeDuration: {
            startTime: dayjs().get('h'),
            endTime: dayjs().add(1,'h').get('h'),
          },appointmentsData:[]}));
          return Promise.resolve(response);
        }
      

        // for loop for each appointments to add and merage the appointment date with appointment_calendar_time_of_day
        let appointmentsData =await response.map((appointment,index) => {
          const {
            appointment_calendar_date,
            appointment_calendar_time_of_day,
            patient_info_birthday,schedule_template_time_period,
            patient_first_name,patient_last_name,patient_second_name,
            appointment_exception_notes,
            appointment_exception_id ,
            appointment_exception_is_all_day
          } = appointment;

          // split appointment_calendar_time_of_day into variables
          const [timeOfDayhour, timeOfDayMinute] =
            appointment_calendar_time_of_day.split(':');

          // change hour and minute for the appointment to the same as appointment_calendar_time_of_day time
          let formatedDate = dayjs(appointment_calendar_date).format('YYYY-MM-DD');
          formatedDate += ` ${timeOfDayhour}:${timeOfDayMinute}`;

          // set appointment startDate
          appointment['startDate'] = formatedDate;
          appointment['endDate'] = dayjs(formatedDate).add(schedule_template_time_period,'m').format('YYYY-MM-DD HH:mm:ss');
          // change appointment_calendar_date to the new one
          appointment['appointment_calendar_date'] = formatedDate;

          // check if age is available then caleculate and format it like this (years.months)
          if (patient_info_birthday) {
            const calculatedAge = CaleculateAge(patient_info_birthday);
            appointment['patient_info_birthday_month'] = calculatedAge.month;
            appointment['patient_info_birthday_year'] = calculatedAge.year;
            appointment['patient_info_age'] = `${calculatedAge.year}.${calculatedAge.month}`;
          } else {
            appointment['patient_info_age'] = null;
          }

 
          if (appointment_exception_id !== null) {
            appointment['allDay'] = appointment_exception_id == -1 || appointment_exception_is_all_day;
            if(Number(appointment_exception_id) === -1){
              appointment['title'] = 'عطلة';
       
            }else{
            
              if(appointment_exception_notes !==  null && appointment_exception_notes.match(/^ *$/) === null){
                appointment['title'] = (appointment_exception_notes) ;
              }else{
                appointment['title'] = 'استثناء';
              }
           
          }

          } else {
           
              if (patient_first_name !== null) {
                appointment['title'] = `${patient_first_name || ''} ${
                  patient_second_name || ''
                } ${patient_last_name || ''}`;
              }else
              
              if (appointment['patient_info_age'] !== null) {
                appointment[
                  'title'
                ] = `${appointment['title']} (${appointment['patient_info_age']})`;
              }
             
           
          }


      
          return appointment;
        });
       

        const { schedule_template_time_period } = appointmentsData[0] || 30;

   
        // get only appointments that don't have allDay
        let availableTimeAppointments = appointmentsData.filter(appointment=> appointment.appointment_exception_id == null);
         // combine dublicated exception_id that have all_day is set to true 
        let exceptionAppointmentsData = appointmentsData.reduce(function (a, b) {
          if ( b.allDay == true && 
            Number(b.appointment_exception_id) !== -1 
            &&  (a.map((a) => dayjs(a.startDate).format('YYYY-MM-DD'))).indexOf(dayjs(b.startDate).format('YYYY-MM-DD')) < 0
          )
            a.push(b);
          return a;
        }, []);

 

        let weekendAppointments = appointmentsData.reduce(function (a, b) {
          if (
            Number(b.appointment_exception_id) == -1 && 
            (a.map((a) => dayjs(a.startDate).format('YYYY-MM-DD'))).indexOf(dayjs(b.startDate).format('YYYY-MM-DD')) < 0
          ){
            
            a.push(b);
          }
          return a;
        }, []);
   
        appointmentsData = appointmentsData.sort((a, b) => dayjs(a.startDate).format('HH') > dayjs(b.startDate).format('HH')? 1 : dayjs(b.startDate).format('HH') > dayjs(a.startDate).format('HH') ? -1: 0 );


        // get only exceptions that has appointent_exception_id and all_day == false 
        let exceptionsData = appointmentsData.filter(ap=>ap.allDay !== undefined && ap.allDay !== true && ap.appointment_exception_id !== null && Number(ap.appointment_exception_id) !== -1) ;

        /// remove all exceptions that has allDay = false , means that we have only allDay = true & available time appointments ;
        appointmentsData = appointmentsData.filter(ap=>ap.allDay !== false && ap.allDay!== true && Number(ap.appointment_exception_id) !== -1) ;


        /// sorting exceptionsData by day, hour and minute
        exceptionsData = exceptionsData.sort((a, b) =>{
          const [aHour, aMinute] = a.appointment_calendar_time_of_day.split(':') ;
          const [bHour, bMinute] = b.appointment_calendar_time_of_day.split(':') ;
          const aDayNumber = dayjs(a.startDate).format('DD'); 
          const bDayNumber = dayjs(b.startDate).format('DD'); 
          const calculatedStartDateA = (Number(aDayNumber)* 1440) + Number(Number(aHour) * 60) + Number(aMinute) ;
          const calculatedStartDateB =  (Number(bDayNumber)* 1440) + Number(Number(bHour) * 60) + Number(bMinute) ;
          if ( calculatedStartDateA < calculatedStartDateB ){
            return -1;
          }
          if ( calculatedStartDateA > calculatedStartDateB ){
            return 1;
          }
          return 0 ;
        });


        // combine similar exceptions into one appointment
        let combinedExceptions = exceptionsData.reduce(function (a, b) {
              
          const similarExceptionIndex = a.findIndex((appointment)=> {
                 const startTime = dayjs(appointment.startDate).format('HH:mm') ;
                const DayNumber = dayjs(appointment.startDate).format('DD'); 
                const BDayNumber = dayjs(b.startDate).format('DD'); 
                const BstartTime = dayjs(b.startDate).format('HH:mm') ;
                const [, minuteStartTime] = startTime.split(':') ;
                const [, minuteBStartTime] = BstartTime.split(':') ;
                const calculatedStartTime = (Number(DayNumber)* 1440)   + Number(minuteStartTime); 
                const calculatedBStartTime = (Number(BDayNumber)* 1440)  + Number(minuteBStartTime); 
                const isSameTime = ((calculatedStartTime - calculatedBStartTime) >= schedule_template_time_period) 
                || ((calculatedBStartTime - calculatedStartTime) <= schedule_template_time_period);
               

                const isSameDay = dayjs(appointment.startDate).isSame(dayjs(b.startDate),'d');
                return  isSameTime && isSameDay && appointment.appointment_exception_id == b.appointment_exception_id  ;
                
            }) ;
            
              if(similarExceptionIndex > -1){
                 a[similarExceptionIndex] = {...a[similarExceptionIndex],endDate:b.endDate} ;
              }else{
                a.push(b);
               }
            
        
          return a;
        }, []);
         

        // combining weekends, exceptions, all day exceptions and available time. into appointments
        appointmentsData = appointmentsData.concat(exceptionAppointmentsData);
        appointmentsData = appointmentsData.concat(weekendAppointments);
        appointmentsData = appointmentsData.concat(combinedExceptions);
        appointmentsData = appointmentsData.concat(availableTimeAppointments);
 
        
        appointmentsData = appointmentsData.sort((a, b) => dayjs(a.startDate).format('HH') > dayjs(b.startDate).format('HH')? 1 : dayjs(b.startDate).format('HH') > dayjs(a.startDate).format('HH') ? -1: 0 );
 

        // remove dublicated appointments
        appointmentsData = appointmentsData.reduce(function (a,b){

          if(a.map((app)=> app.appointment_calendar_id).indexOf(b.appointment_calendar_id) < 0){
            a.push(b) ;
          }
          return a ;
        },[]);

        appointmentsData = appointmentsData.sort((a, b) => dayjs(a.startDate).format('HH') > dayjs(b.startDate).format('HH')? 1 : dayjs(b.startDate).format('HH') > dayjs(a.startDate).format('HH') ? -1: 0 );

        const firstStartTime = dayjs(appointmentsData[0].startDate ).format('HH') ;
        const lastEndTime = dayjs(appointmentsData[appointmentsData.length - 1].endDate).format('HH') ;  
        const startTime = lastEndTime < 12 ? lastEndTime : firstStartTime ; 
        const endTime = Number( lastEndTime > 12 ? lastEndTime : firstStartTime )  ; 
        const timePeriod = (function (){
          if( appointmentsData.length < 1 || !appointmentsData[0]){
          return 30; 
          }
          const firstScheduleTemplateTimePeriod =  appointmentsData[0] &&  appointmentsData[0].schedule_template_time_period !== null ?  appointmentsData[0].schedule_template_time_period : 30;  ;
          const lastScheduleTemplateTimePeriod = appointmentsData[appointmentsData.length - 1]&&  appointmentsData[appointmentsData.length - 1].schedule_template_time_period !== null ?  appointmentsData[appointmentsData.length - 1].schedule_template_time_period : 30;  ;
          const checkLarger = firstScheduleTemplateTimePeriod > lastScheduleTemplateTimePeriod; 
          const checkNull = firstScheduleTemplateTimePeriod == null || lastScheduleTemplateTimePeriod == null;
          return checkNull ? 30 : (checkLarger ? lastScheduleTemplateTimePeriod : firstScheduleTemplateTimePeriod); 
        })();
     

        // set the calendar start and end time
        const calendar = {
          cellTimeDuration: timePeriod,
          timeDuration: { startTime: startTime, endTime : endTime },
          appointmentsData};
        
        return Promise.resolve(calendar);
      })
      .catch((err) => {
        console.error(err);
        return Promise.reject(err);
      });
     
    return await result ;
  };

  React.useEffect(() => {
      try{

        getAppointmentsCalendar(currentWeek).then(async response=>{
          
          setCalendarConfig(old=>({...old,...response}));  
          
          setLoading(false);
        }).catch((err) => {
          setError(true);
          console.log('error',err);
        });
        getExceptionDates().then(async response=>{
        setCalendarConfig(old=>({...old,exceptionDates:[...response]}));
        
      }).catch((err) => {
        setError(true);
        console.log('error',err);
      });
    }catch(err) {
      setError(true);
      console.log('error',err);
    }
      setLoading(false);

  }, [currentWeek]);
  
  React.useEffect(() => {
    setContext(oldContext=>({...oldContext,...calendarConfig}));
 
  },[calendarConfig]);

  const errorMessage =
    !loading && isError ? (
      <Stack sx={{ width: '100%' }} spacing={2}>
        <Alert
          severity="error"
          action={
            <Button
              onClick={() => getAppointmentsCalendar(currentWeek)}
              color="inherit"
              startIcon={<Refresh />}
              size="small"
            >
              {Localization.translate['reload']}
            </Button>
          }
        >
          {Localization.translate['error']}
        </Alert>
      </Stack>
    ) : (
      ''
    );

  const EmptyMessage =
    showEmptyDataAlert && !loading ? (
      <div style={{width:'100%',textAlign:'center',display:'flex',flexDirection:'column',alignItems:'center',gap:'1rem'}} >
      <Box style={{background:'#D9D9D9',color:'#000000',fontWeight:'bold',width:'100%',padding:5}}>
         {Localization.translate['empty_appointments_alert']}
      </Box>
      <StyledButton variant="contained" startIcon={<AddOutlined />} onClick={() => changeDialogsOpenState('availableTimeOpen',true)} >{Localization.translate['add_full_month']}</StyledButton>
      </div>
    ) : (
      ''
    );

  return (
    <>
      <Helmet>
        <title>{`${Localization.translate['app_name']} | ${Localization.translate['appointments_calendar']}`}</title>
      </Helmet>
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          {errorMessage}
      
          <CalendarHeader dialogs={dialogs} changeDialogsOpenState={changeDialogsOpenState} />
          <Grid
            container
            spacing={2}
            justify="center"
            sx={{ justifyContent: 'center' }}
          >
            {!loading ? (
              <CalendarTopbar
                setNextWeekDate={setNextWeekDate}
                setPreviousWeekDate={setPreviousWeekDate}
              />
            ) : (
              <Skeleton />
            )}
            <Grid item xs={12} sx={{ height: '100%' }}>
              {!loading ? (
                <Calendar  {...calendarConfig} />
              ) : (
                <Skeleton
                  variant="rectangular"
                  width={'100%'}
                  height={'40rem'}
                />
              )}
            </Grid>
          </Grid>
          {EmptyMessage}
        </Grid>
      </Container>
    </>
  );
}
